import React from 'react';

import { IMenuItem } from 'client/common/types';

import { cnSidebar } from '../sidebar';

interface ISidebarMenuItemProps {
    item: IMenuItem;
    index: number;
    onItemClick: (index: number) => void;
}

function SidebarMenuItem({ item, index, onItemClick }: ISidebarMenuItemProps) {
    const hasItems = item.items && item.items.length;

    return (
        <a
            className={cnSidebar('item', { current: item.isCurrent })}
            onClick={onClick}
            href={item.url}
            >
            {hasItems && <div className={cnSidebar('arrow')} />}
            <span dangerouslySetInnerHTML={{ __html: item.title }} />
        </a>
    );

    function onClick() {
        onItemClick(index);
    }
}

export default SidebarMenuItem;
